(function () {
  const STYLE_ID = "byte-qvl-quantity-override";
  const WRAPPER_SELECTOR = ".qvl-wholesale .qvl-input-wrapper";
  const INPUT_SELECTOR =
    ".qvl-input__quantity input, .qvl-wholesale .qvl-basic-input";
  const OPTION_NAME_SELECTOR = ".qvl-wholesale__option-name > span";
  const APPLY_DELAYS_MS = [0, 300, 800, 1600, 3200];
  const OBSERVER_DEBOUNCE_MS = 50;

  const OPTION_NAME_LABELS = {
    size: "Ebat",
    color: "Renk",
    colour: "Renk",
  };

  const OVERRIDE_CSS = `
    ${WRAPPER_SELECTOR}:before,
    ${WRAPPER_SELECTOR}::before {
      border-radius: 32px !important;
    }

    .qvl-wholesale .qvl-input__quantity input,
    .qvl-wholesale .qvl-input-wrapper .qvl-basic-input {
      width: 100% !important;
    }
  `;

  let applyTimeoutId = null;
  let isApplyingOverrides = false;

  function ensureOverrideStylesheet() {
    let styleElement = document.getElementById(STYLE_ID);

    if (!styleElement) {
      styleElement = document.createElement("style");
      styleElement.id = STYLE_ID;
      styleElement.textContent = OVERRIDE_CSS;
    }

    document.head.appendChild(styleElement);
  }

  function applyInlineOverrides() {
    const wrappers = document.querySelectorAll(WRAPPER_SELECTOR);

    for (const wrapper of wrappers) {
      wrapper.style.setProperty("padding", "1rem", "important");
      wrapper.style.setProperty("width", "14rem", "important");
      wrapper.style.setProperty(
        "justify-content",
        "space-between",
        "important",
      );
    }

    const inputs = document.querySelectorAll(INPUT_SELECTOR);

    for (const input of inputs) {
      input.style.setProperty("width", "100%", "important");
    }
  }

  function translateOptionNames() {
    const optionNameSpans = document.querySelectorAll(OPTION_NAME_SELECTOR);

    for (const optionNameSpan of optionNameSpans) {
      const optionNameKey = optionNameSpan.textContent.trim().toLowerCase();
      const translatedLabel = OPTION_NAME_LABELS[optionNameKey];

      if (!translatedLabel) continue;

      optionNameSpan.textContent = translatedLabel;
    }
  }

  function applyQvlOverrides() {
    if (isApplyingOverrides) return;

    isApplyingOverrides = true;

    try {
      ensureOverrideStylesheet();
      applyInlineOverrides();
      translateOptionNames();
    } finally {
      isApplyingOverrides = false;
    }
  }

  function scheduleApplyQvlOverrides() {
    if (applyTimeoutId !== null) {
      clearTimeout(applyTimeoutId);
    }

    applyTimeoutId = setTimeout(() => {
      applyTimeoutId = null;
      applyQvlOverrides();
    }, OBSERVER_DEBOUNCE_MS);
  }

  function observeQvlDom() {
    const observer = new MutationObserver(scheduleApplyQvlOverrides);

    // Required because QVL injects and re-renders option labels after load.
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function start() {
    for (const delay of APPLY_DELAYS_MS) {
      setTimeout(applyQvlOverrides, delay);
    }

    observeQvlDom();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }

  window.addEventListener("load", applyQvlOverrides, { once: true });
})();
